<template>
    <div class="footer clearfix">
        
        <TheFooterIndex 
            v-if=" path == '/'" 
            key="'IndexFooter'" 
        />

        <TheFooterOther 
            v-else 
            key="'FooterOther'" 
        />      

        <div class="footer-icp">
           <!-- <span>&#169 2019 喜得数字技术</span>  <a class="icp" target="_blank" href="http://beian.miit.gov.cn">京ICP备xxxxxx-1</a> -->
           <span class="copyright">&#169; 2019 喜得数字技术 / Xidespace</span>  <a class="icp" target="_blank" href="http://beian.miit.gov.cn">京ICP备19013868号</a>
        </div>
    </div>
</template>
<script>

import TheFooterIndex from '@/components/module/TheFooterIndex'
import TheFooterOther from '@/components/module/TheFooterOther'

export default {
    name: 'Footer',
    props: {
        // msg: String
    },
    components: {
        TheFooterIndex,
        TheFooterOther
    },
    data: function(){
        return {
            path: this.$route.path,
        }
    },  
    mounted() {

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>